import React , {useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Badge, Row, Col, Container, Card, Form, Button, ListGroup, OverlayTrigger, Popover, Tooltip, Carousel, InputGroup, FormControl, Table } from 'react-bootstrap'


import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';


import Meta from '../../components/Meta'


export const LaeyerzScreen = ({match, history}) => {

    
    const dispatch = useDispatch()



    const [newModel, setNewModel] = useState("") 

    const [data, setData] = useState([])






    useEffect(() => {
       

    }, [])





    return(
        <div style={{ marginTop: '0px', fontFamily: 'Roboto, Inter, "Open Sans", Arial, sans-serif', background: '#f8f9fa', minHeight: '100vh' }}>
            <Meta title={'Laeyerz'} description={'Laeyerz is a python library to build simple RAG applications and Agentic AI systems with minimal coding.'} />

            {/* Hero Section */}
            {/* <section style={{
                background: 'linear-gradient(90deg, #f0f2f2 60%, #e6e6fa 100%)',
                padding: '48px 0 32px 0',
                textAlign: 'center',
                borderBottom: '1px solid #e0e0e0',
                marginBottom: 32,
            }}>
                <h1 style={{
                    fontWeight: 800,
                    fontSize: '2.4rem',
                    color: '#0C0854',
                    letterSpacing: '0.01em',
                    marginBottom: 12,
                    fontFamily: 'Roboto, Inter, "Open Sans", Arial, sans-serif',
                }}>Laeyerz</h1>
                <h4 style={{
                    color: '#6b0752',
                    fontWeight: 500,
                    marginBottom: 0,
                    fontSize: '1.2rem',
                }}>
                    Laeyerz is an Open-source python library designed to  prototype and visualize LLM applications and Agentic systems
                </h4>
            </section> */}

            <Container fluid style={{ width: '100vw', maxWidth: '100vw', padding: 0, margin: 0, marginTop:'20px' }}>
                <Row className="justify-content-center" style={{ margin: 0 }}>
                    <Col xs={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 0 }}>

                    <Card style={{ width: '96vw', maxWidth: 1100, marginBottom: '18px', border: 'none', borderRadius: 18, boxShadow: '0 2px 16px rgba(0,0,0,0.07)', padding: '28px' }}>
                    <h1 style={{
                    fontWeight: 800,
                    fontSize: '2.4rem',
                    color: '#0C0854',
                    letterSpacing: '0.01em',
                    marginBottom: 2,
                    fontFamily: 'Roboto, Inter, "Open Sans", Arial, sans-serif',
                }}>Laeyerz</h1>
                <p className='h5'>https://laeyerz.com/</p>
                <p className='h4' style={{
                    color: '#6b0752',
                    fontWeight: 500,
                    marginBottom: 0,
                    marginTop: 10,
                    fontSize: '1.2rem',
                }}>
                    Laeyerz is an Open-source python library designed to  prototype and visualize LLM applications and Agentic systems
                </p>
                        </Card>
                        {/* Getting Started Card */}
                        <Card style={{ width: '96vw', maxWidth: 1100, marginBottom: '18px', border: 'none', borderRadius: 18, boxShadow: '0 2px 16px rgba(0,0,0,0.07)', padding: '28px' }}>
                            <h2 style={{ fontWeight: 700, color: '#0C0854', marginBottom: 18, fontSize: '1.5rem' }}>Getting Started</h2>
                            <p className='h5'>You can find Laeyerz on github at <a style={{ color: '#7b2ff7' }} href='https://github.com/pixagan/Laeyerz'>https://github.com/pixagan/Laeyerz</a></p>
                            <p className='h5'>Download the repository and install the dependencies.</p>
                            <SyntaxHighlighter language='bash'>
                                git clone https://github.com/pixagan/Laeyerz.git
                            </SyntaxHighlighter>
                            <p className='h5'>Install the dependencies.</p>
                            <SyntaxHighlighter language='bash'>
                                cd laeyerz
                            </SyntaxHighlighter>
                            <SyntaxHighlighter language='bash'>
                                pip install -r requirements.txt
                            </SyntaxHighlighter>
                            <p className='h5'>Now use pip install -e . to install the package locally.</p>
                            <SyntaxHighlighter language='bash'>
                                pip install -e .
                            </SyntaxHighlighter>
                        </Card>

{/*                       
                        <Card style={{ width: '96vw', maxWidth: 1100, marginBottom: '18px', border: 'none', borderRadius: 18, boxShadow: '0 2px 16px rgba(0,0,0,0.07)', padding: '28px' }}>
                            <h2 style={{ fontWeight: 700, color: '#0C0854', marginBottom: 18, fontSize: '1.5rem' }}>Requirements</h2>
                            <Table striped bordered hover style={{ margin: '20px', background: '#fff', borderRadius: 12 }}>
                                <thead>
                                    <tr>
                                        <th>Component</th>
                                        <th>Supported Technologies</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Session Storage</td>
                                        <td>MongoDB</td>
                                    </tr>
                                    <tr>
                                        <td>Vector Database</td>
                                        <td>Pinecone</td>
                                    </tr>
                                    <tr>
                                        <td>LLM</td>
                                        <td>OpenAI</td>
                                    </tr>
                                    <tr>
                                        <td>Embedding Model</td>
                                        <td>OpenAI, HuggingFace</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Card>

                    
                        <Card style={{ width: '96vw', maxWidth: 1100, marginBottom: '18px', border: 'none', borderRadius: 18, boxShadow: '0 2px 16px rgba(0,0,0,0.07)', padding: '28px' }}>
                            <h2 style={{ fontWeight: 700, color: '#0C0854', marginBottom: 18, fontSize: '1.5rem' }}>To start using Laeyerz</h2>
                            <p className='h5'>Select the configuration.</p>
                            <SyntaxHighlighter language='python'>
{`config = {
    "appname": "Example 1",
    "LLM": {"vendor": "OpenAI", "model": "gpt-4o"},
    "VectorDB": "Pinecone",
    "VectorDB_Params": {
        "index_name": "example2-index",
        "namespace": "example2-namespace",
        "dimension": 384,
        "metric": "cosine",
        "spec": "serverless"
    },
    "EmbeddingModel": {"vendor": "HuggingFace", "model_name": "paraphrase-MiniLM-L6-v2"},
    "NoSQL": "Mongo",
    "GraphDB": "None"
}`}
                            </SyntaxHighlighter>
                            <p className='h5'>Create an instance of Laeyerz.</p>
                            <SyntaxHighlighter language='python'>
ly = Laeyerz(settings)
                            </SyntaxHighlighter>
                        </Card>

                        <Card style={{ width: '96vw', maxWidth: 1100, marginBottom: '18px', border: 'none', borderRadius: 18, boxShadow: '0 2px 16px rgba(0,0,0,0.07)', padding: '28px' }}>
                            <h2 style={{ fontWeight: 700, color: '#0C0854', marginBottom: 18, fontSize: '1.5rem' }}>Laeyerz accepts information in the form of documents.</h2>
                            <SyntaxHighlighter language='python'>
{`document = {
    "type": "report",
    "title": "Example 1",
    "chunks": [
        {"text": "Retrieval-Augmented Generation (RAG) is an AI framework that enhances ..."},
        {"text": "Different LLMs and databases play crucial roles in .."},
        {"text": "RAG is widely used in applications that ...."}
    ]
}`}
                            </SyntaxHighlighter>
                            <p className='h5'>As each document is added Laeyerz will store the document in its memory structure. You can directly start querying the documents.</p>
                            <SyntaxHighlighter language='python'>
ly.add_document(document,'report')
                            </SyntaxHighlighter>
                            <p className='h5'>To ask questions create a session</p>
                            <SyntaxHighlighter language='python'>
session = ly.create_session("Session Name")
                            </SyntaxHighlighter>
                        </Card>

                        <Card style={{ width: '96vw', maxWidth: 1100, marginBottom: '18px', border: 'none', borderRadius: 18, boxShadow: '0 2px 16px rgba(0,0,0,0.07)', padding: '28px' }}>
                            <h2 style={{ fontWeight: 700, color: '#0C0854', marginBottom: 18, fontSize: '1.5rem' }}>Loading an Existing Session</h2>
                            <SyntaxHighlighter language='python'>
session = ly.load_session("Session Name")
                            </SyntaxHighlighter>
                        </Card>

                        <Card style={{ width: '96vw', maxWidth: 1100, marginBottom: '18px', border: 'none', borderRadius: 18, boxShadow: '0 2px 16px rgba(0,0,0,0.07)', padding: '28px' }}>
                            <h2 style={{ fontWeight: 700, color: '#0C0854', marginBottom: 18, fontSize: '1.5rem' }}>Chat with Laeyerz</h2>
                            <p className='h5'>Once the session is loaded chat with Laeyerz. It will use the memories and the LLM to respond to the query.</p>
                            <SyntaxHighlighter language='python'>
{`response = curr_session.chat(

    {   
        "instructions":"Respond to the user's query based on the provided information.",
        "query":"What are the applications of RAG?"
    }
)`}
                            </SyntaxHighlighter>
                            <p className='h5'>The response will be stored in the session memory.</p>
                        </Card>

                        <Card style={{ width: '96vw', maxWidth: 1100, marginBottom: '18px', border: 'none', borderRadius: 18, boxShadow: '0 2px 16px rgba(0,0,0,0.07)', padding: '28px' }}>
                            <h2 style={{ fontWeight: 700, color: '#0C0854', marginBottom: 18, fontSize: '1.5rem' }}>Examples</h2>
                            <p className='h5'>You can checkout more examples and use cases in the examples folder of the github repository.</p>
                        </Card> */}




                    </Col>




                </Row>



            </Container>
        </div>
    )
}

export default LaeyerzScreen


